import React, { useEffect } from "react";
import history from "@dhn/shared/history";
import { beginPendingTask } from "@dhn/shared/pending-tasks";
import LoadingDhn from "./LoadingDhn";
import useRouteChangeLoading from "./use-route-change-loading";

// Carga global entre módulos: se abre al cambiar de ruta y se cierra cuando el
// módulo nuevo terminó de descargarse y de consultar sus datos.
export default function RouteChangeLoading() {
  const isOpen = useRouteChangeLoading(history);

  return <LoadingDhn isOpen={isOpen} isDescription={false} />;
}

// Fallback de Suspense: registra la descarga del módulo diferido y deja que
// RouteChangeLoading muestre una sola carga continua.
export function SuspenseLoadingFallback() {
  useEffect(() => beginPendingTask("suspense"), []);

  return null;
}
